import { MiButton, MiMenu } from "@miplatform/components";
import { Palette } from "@mui/material";

export const ConfigMenu = ({
  data,
  disabled,
  optionalElement,
}: IConfigMenuProps) => {
  return (
    optionalElement && (
      <MiMenu
        data={data}
        disabled={disabled}
        optionalElement={
          <MiButton
            size={optionalElement.size}
            title={optionalElement.title}
            color={optionalElement.color}
            endIcon={optionalElement.endIcon}
            sx={optionalElement.sx}
            variant="contained"
            disabled={disabled}
          />
        }
      />
    )
  );
};

interface IConfigMenuProps {
  data: any[];
  disabled?: boolean;
  optionalElement: {
    size: "small" | "medium" | "large";
    title: string;
    color: keyof Palette;
    endIcon?: { path: string };
    sx: object;
  };
}
